import { useAuth0 } from '@auth0/auth0-react';

import { SendNudgeSection } from '@/features/proactive-agents/SendNudgeSection';
import { useBuiltinAgents } from '@/features/proactive-agents/useProactiveAgents';
import { UserAgentsSection } from '@/features/proactive-agents/UserAgentsSection';

export const ProactiveAgentsPage = () => {
  const adminEmail = useAuth0().user?.email ?? '';
  const codeDefault = useBuiltinAgents().data?.code_default;
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-semibold tracking-tight">
          Proactive Agents
        </h2>
        <p className="text-sm text-muted-foreground">
          Manage users&apos; proactive agents.
        </p>
        {codeDefault ? (
          <p className="mt-2 text-sm">
            Code default agent: <span className="font-mono">{codeDefault}</span>
            . Users get it as their default unless an admin sets one for them
            below, or an internal user presses Set as default in their settings.
            Either choice is saved as an override, which stays even if the code
            default changes.
          </p>
        ) : null}
      </div>
      <UserAgentsSection key={`users-${adminEmail}`} adminEmail={adminEmail} />
      <SendNudgeSection key={`nudges-${adminEmail}`} adminEmail={adminEmail} />
    </div>
  );
};
